import { getVar } from "config";

export const API_PATH = "/api/internal";

const getApiHostName = (): URL => {
  if (getVar("REACT_APP_PREVIEW_HOST")) {
    return new URL(getVar("REACT_APP_PREVIEW_HOST") || "") as URL;
  }

  return new URL(getVar("REACT_APP_API_HOST")) as URL;
};

const getAPIHost = (): URL["host"] => new URL(API_PATH, getApiHostName()).host;
const getAPIUrl = (): URL["href"] => new URL(API_PATH, getApiHostName()).href;
const getAPIOrigin = (): URL["origin"] =>
  new URL(API_PATH, getApiHostName()).origin;

export { getAPIHost, getAPIUrl, getAPIOrigin };
